export default "__VITE_ASSET__CqsynFOk__"